module.exports = __webpack_public_path__ + "static/cn-ef6c9be54a9a9fc8cba51df2195f234d.png";